import request from '@/utils/request'
// 登录
export const login = (phone, code, type, password) => {
  return request.post('/user/login', {
    phone, code, type, password
  })
}
// 注册
export const register = (phone, code, password, inviter) => {
  return request.post(`/user/register?inviter=${inviter}`, {
    phone, code, password
  })
}
// 获取其他人的用户资料
export const getUserInfo = (id) => {
  if (id == null) {
    return
  }
  return request.get(`/user/${id}`)
}
// 获取用户权限
export const getUserAuth = (type) => {
  return request.get(`/userauth?type=${type}`)
}

// 获取自己的用户资料，由于get接口被占用了，所以此处将get请求改为post，该接口会进行身份认证
export const getMyUserInfo = () => {
  return request.post('/user/my')
}
// 获取自己的用户招募信息资料，由于get接口被占用了，所以此处将get请求改为post，该接口会进行身份认证
export const getMySolicitorInfo = () => {
  return request.post('/solicitors/my')
}
// 获取用户的玩家信息资料
export const getPlayerInfo = (id) => {
  if (id == null) {
    return
  }
  return request.get(`/playinfos/${id}`)
}
export const updateUserInfo = (user) => {
  return request.put('/user', user)
}
export const updatePlayerInfo = (playerInfo) => {
  return request.put('/playinfos', playerInfo)
}
